import {
  HEX_233C57,
  HEX_292D38,
  HEX_3B93EE,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_68727F,
  HEX_90C3E3,
  HEX_ADB5C7,
  HEX_CED7E2,
  HEX_ECF4FF,
  HEX_FFFFFF,
} from '@tanium/colors';
import { defineColor, Foreground2, ForegroundState1 } from '@tanium/react-theme-definition';

export const PrimaryText = Foreground2;
export const PrimaryHover = ForegroundState1;
export const PrimaryActive = defineColor([HEX_3E4B68, HEX_477FBA]);
export const PrimarySelectedText = Foreground2;
export const PrimaryDisabledText = defineColor([HEX_ADB5C7, HEX_68727F]);

export const SubtleText = defineColor([HEX_CED7E2, HEX_233C57]);

export const SubduedText = defineColor([HEX_477FBA, HEX_ADB5C7]);

export const InvertedText = defineColor([HEX_FFFFFF, HEX_477FBA]);
export const InvertedHoverText = defineColor([HEX_ECF4FF, HEX_3B93EE]);
export const InvertedActiveText = defineColor([HEX_90C3E3, HEX_3E4B68]);
export const InvertedSelectedText = defineColor([HEX_3B93EE, HEX_292D38]);
export const InvertedDisabledText = defineColor([HEX_ADB5C7, HEX_ADB5C7]);
